export default __webpack_public_path__ + "497f86056fa49106021824243b0fc50d.png";